import { cl, CustomElement, isDesktop, scrollLock, scrollUnLock } from '@/utils';
import { bus } from '@/bus';

export default class Menu extends CustomElement {
  static component = 'b-menu';
  static open = 'open';
  static busy = 'busy';
  static hovered = 'hovered';
  static observedAttributes = [Menu.open];
  static open_class = 'menu-open';

  burger: HTMLElement;
  menuInner: HTMLElement;

  init() {
    this.burger = this.$('menu-toggle');
    this.menuInner = this.$('menu-inner');

    this.burger.addEventListener('click', () => {
      this.toggle();
    });

    bus.on('barba_leave', () => {
      this.close();
    })

    bus.on('cancel', () => {
      this.close();
    });

    bus.on('cartToggle', () => {
      this.close();
    });

    bus.on('click', (ev) => {
      const withinBoundaries = ev.composedPath().includes(this)

      if (!withinBoundaries) {
        this.close();
      }
    });
  }



  changed(prop: string, value: string) {
    if (prop === Menu.open) {
      if (value === '') {
        cl(document.body).add(Menu.open_class);
      } else {
        cl(document.body).remove(Menu.open_class);
      }
    }
  }

  open() {
    this.setAttribute(Menu.open, '');
    bus.emit('menuToggle');
    if (!isDesktop(768)) {
      scrollLock(this.menuInner);
    }
  }

  close() {
    this.removeAttribute(Menu.open);
    scrollUnLock();
  }

  toggle() {
    this.hasAttribute(Menu.open) ? this.close() : this.open();
  }
}
